import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { FlashCardModel } from 'src/app/api/models';
import { DecimalPipe } from '@angular/common';
import { MockPhoneComponent } from '../common/mock-phone.component';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { NgScrollbar } from 'ngx-scrollbar';
import { MarkdownKatexComponent } from '../../widget/markdown-katex/markdown-katex.component';
import { MatButton, MatAnchor } from '@angular/material/button';
import { EnvPipe } from 'src/app/utility/env.pipe';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'qa-flash-card-mock-phone',
  templateUrl: './flash-card-mock-phone.component.html',
  styleUrls: ['./flash-card-mock-phone.component.scss'],
  imports: [
    MockPhoneComponent,
    MatIcon,
    MatTooltip,
    NgScrollbar,
    MarkdownKatexComponent,
    MatButton,
    MatAnchor,
    DecimalPipe,
    EnvPipe,
    TranslateModule,
  ],
})
export class FlashCardMockPhoneComponent {
  @Input() itemCount: number;
  @Input() currentItemPosition = 1;
  @Input()
  flashCard: FlashCardModel;
  isExplanationPanelOpen = false;

  showAnswer = false;

  constructor(private domSanitizer: DomSanitizer) {}

  openExplainPanel(event, open): void {
    if (open) {
      event.stopPropagation();
      this.isExplanationPanelOpen = !this.isExplanationPanelOpen;
    }
  }

  getWeblink(): SafeUrl {
    let weblink = this.flashCard.weblink;
    if (!weblink) {
      return null;
    }
    if (!weblink.includes('http')) {
      weblink = `http://${weblink}`;
    }
    return this.domSanitizer.bypassSecurityTrustUrl(weblink);
  }
}
